import { useGetDictionaries as useGetExternalDictionaries } from "@synthesis/shared-services/external/dictionaries/hooks";
import { useGetDictionaries as useGetInternalDictionaries } from "@synthesis/shared-services/internal/dictionaries/hooks";
import { useMemo } from "react";

import type { ClientType } from "./use-client-type";
import {
  buildCreateApplicationDictionaries,
  EMPTY_CREATE_APPLICATION_DICTIONARIES,
  type CreateApplicationDictionaries,
} from "../../pages/create-application-page/create-application-dictionaries.lib";

type UseApplicationDictionariesResult = {
  dictionaries: CreateApplicationDictionaries;
  isLoading: boolean;
  isError: boolean;
};

export const useApplicationDictionaries = (clientType: ClientType): UseApplicationDictionariesResult => {
  const isExternal = clientType === "external";
  const isInternal = clientType === "internal";

  const externalQuery = useGetExternalDictionaries({
    query: { enabled: isExternal },
  });

  const internalQuery = useGetInternalDictionaries({
    query: { enabled: isInternal },
  });

  const query = isInternal ? internalQuery : externalQuery;

  const dictionaries = useMemo(
    () => (query.data ? buildCreateApplicationDictionaries(query.data) : EMPTY_CREATE_APPLICATION_DICTIONARIES),
    [query.data],
  );

  return {
    dictionaries,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
